import axios from "axios";

import { baseURL } from "../../../Config";

import { LOCAL_STORAGE_KEY } from "../../../Config";
import { IsLogin } from "../../../../src/utils";
import { NotificationManager } from "react-notifications";

const instance = axios.create({
  baseURL: baseURL,
});

instance.interceptors.request.use((config) => {
  const userdata = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
  );
  if (userdata) {
    config.headers.Authorization = `Bearer ${userdata.access_token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (IsLogin()) {
      if (error.response.status === 401) {
        localStorage.clear();
        alert("Login expired!");
        window.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
